import { CloseRounded } from '@mui/icons-material'
import { Button, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import useMassAssignmentAddedInputs from '../../hooks/useMassAssignmentAddedInputs'
import useMassAssignmentData from '../../hooks/useMassAssignmentData'
import useModalState from '../../hooks/useModalState'
import { IAddedInputs } from '../../models/MassAssignmentAddedInputs'
import { StyledDialog } from '../../styles/StyledDialog'
import MassAssigmentBody from '../MassAssigmentBody'
import { CustomDialogActions } from './CustomDialogActions'

interface MassAssignmentModalProps {
  rows: any
  fields: string[]
  handleSubmit: (data: any) => void
}

const MassAssignmentModal = ({ rows, fields, handleSubmit }: MassAssignmentModalProps) => {
  const { t } = useTranslation(['global'])

  const { open, openModal, closeModal } = useModalState()
  const [data, setData] = useMassAssignmentData()
  const { addedInputs, buttons, addInput, removeInput, handleCheckChange } = useMassAssignmentAddedInputs(fields)

  const handleSave = () => {
    const finalData: any = addedInputs.map((input: IAddedInputs) => ({
      name: input.name,
      value: data[input.name].id ?? data[input.name],
      overwrite: input.checked
    }))

    handleSubmit({ data: finalData, rows })
    closeModal()
  }

  return (
    <>
      {rows.length > 0 && (
        <Button variant="outlined" color="secondary" onClick={() => openModal()}>
          {t('admin.people.massively-assign')}
        </Button>
      )}

      <StyledDialog open={open} onClose={() => closeModal()} aria-labelledby="mass-assigment" aria-describedby="mass-assigment">
        <DialogTitle id="alert-dialog-title">
          <Grid container justifyContent="space-between">
            <Typography variant="h6">{t('admin.people.massively-assign')}</Typography>
            <Button onClick={() => closeModal()} color="primary" variant="text">
              <CloseRounded />
            </Button>
          </Grid>
        </DialogTitle>

        <DialogContent sx={theme => ({ paddingBottom: theme.spacing(3), paddingTop: theme.spacing(2) })}>
          <MassAssigmentBody
            data={data}
            setData={setData}
            addedInputs={addedInputs}
            buttons={buttons}
            addInput={addInput}
            removeInput={removeInput}
            handleCheckChange={handleCheckChange}
          />
        </DialogContent>
        <CustomDialogActions handleSubmit={handleSave} handleClose={closeModal} />
      </StyledDialog>
    </>
  )
}

export default MassAssignmentModal
